import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  OnInit
} from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DeviceHistoryEntry,
  EmptyState,
  FormatDateTimePipe,
  PageWrapper,
  useDeviceStore
} from '@ottobock/remote-update/domain';

import { DeviceDetailsService } from './device-details.service';

@Component({
  selector: 'remote-update-feature-remote-update-dashboard-device-details',
  standalone: true,
  imports: [
    PageWrapper,
    MatCard,
    MatCardTitle,
    MatCardContent,
    MatCardHeader,
    MatTableModule,
    MatPaginator,
    FormatDateTimePipe,
    EmptyState
  ],
  templateUrl: './device-details.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './device-details.css'
})
export class DeviceDetails implements OnInit {
  router = inject(Router);
  route = inject(ActivatedRoute);
  deviceDetailsService = inject(DeviceDetailsService);
  deviceStore = inject(useDeviceStore);

  isLoading = computed(() => this.deviceStore.deviceDetails().loading);
  hasError = computed(() => this.deviceStore.deviceDetails().error !== null);
  deviceDetails = computed(() => this.deviceStore.deviceDetails().data);
  hasNoUpdateHistory = computed(() => this.deviceDetails()?.history?.length === 0);

  dataSource = new MatTableDataSource<DeviceHistoryEntry>([]);

  displayedColumns = [
    'timeStamp',
    'event',
    'installedFirmwareVersion',
    'updateFirmwareVersion',
    'user',
    'remark'
  ];

  packageId = Number(this.route.snapshot.paramMap.get('id'));

  constructor() {
    effect(() => {
      const details = this.deviceDetails();
      if (details?.history) this.dataSource.data = details.history;
    });
  }

  async ngOnInit() {
    if (Number.isNaN(this.packageId)) {
      this.router.navigate(['/']);
      return;
    }

    await this.deviceDetailsService.getDeviceDetails(this.packageId);
  }
}
